import { z } from "zod";

export const scalePrimaryCartonConfigurationSchema = z.object({
	lengthExpression: z.string(),
	widthExpression: z.string(),
	heightExpression: z.string(),
	xValueExpressions: z.record(z.string(), z.string()),
});
